import { useSelector, useDispatch } from 'react-redux';
import * as Styled from '../../styles/ContasAprovados.styles';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button/Button';
import { theme } from '../../../../styles/theme';
import {
  OptionsContainer,
  TitleOptions,
  OptionsContainerProfiles,
} from '../../styles/GerenciarContas.styles';
import formatCEP from '../../../../utils/functions/formatCEP';
import React, { useState, useEffect } from 'react';
import { buscaCep } from '../../../../store/fetchActions/usersActions';
import MenuItem from '@material-ui/core/MenuItem';
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import verifyArray from '../../../../utils/verifyArray';
import InputMask from 'react-input-mask';
import { editUserFetchAction } from '../../../../store/fetchActions/editUsersActions';
import { userFetchAction } from '../../../../store/fetchActions/usersActions';
import FormHelperText from '@mui/material/FormHelperText';
import { detailAccountsFetchAction } from '../../../../store/fetchActions/accountActions';
import { cobansFetchAction } from '../../../../store/fetchActions/cobansActions';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';

const { mainColor, secondaryColor, rbmBlack, rbmWhite } = theme.colors;

export default function UserDetail({
  isEditing,
  cancel,
  errors,
  finall,
  contas,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    contas.ID_CONTA != undefined
      ? dispatch(detailAccountsFetchAction(contas.ID_CONTA))
      : null;
    dispatch(cobansFetchAction());
  }, [contas.ID_CONTA]);

  const { usersData } = useSelector((state) => state.user);
  const { conta, contato, endereco, cliente } = useSelector(
    (state) => state.account.detailAccountsData
  );

  const { cobansData } = useSelector((state) => state.cobans);
  const perfisArray = cobansData.filter((val) => val.CPFCNPJ === null);
  const perfis = perfisArray.filter((val) => val.NOME === usersData.NOMECOBAN);

  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');
  const [idCoban, setIdCoban] = useState(usersData.ID_COBAN);
  const [acessoPdv, setAcessoPdv] = useState(usersData.ACESSO_PDV);
  const [perfil, setPerfil] = useState('');
  const [cep, setCep] = useState('');
  const [rua, setRua] = useState(usersData.ENDERECO);
  const [bairro, setBairro] = useState(usersData.BAIRRO);
  const [cidade, setCidade] = useState(usersData.CIDADE);
  const [uf, setUf] = useState('');
  const [numero, setNumero] = useState(usersData.NUMERO);
  const [complemento, setComplemento] = useState(usersData.COMPLEMENTO);
  const [telefone, setTelefone] = useState(usersData.TELEFONE);
  const [cepError, setCepError] = useState(false);

  useEffect(() => {
    setNome(cliente?.NOME);
    setCpf(cliente?.CPFCNPJ);
    setEmail(contato?.EMAIL);
    setCep(endereco?.CEP);
    setRua(endereco?.ENDERECO);
    setBairro(endereco?.BAIRRO);
    setCidade(endereco?.CIDADE);
    setUf(endereco?.UF);
    setNumero(endereco?.NUMERO);
    setComplemento(endereco?.COMPLEMENTO);
    setTelefone(contato?.FONECEL);
    setPerfil(perfis[0]?.ID);
  }, [conta != undefined]);

  const {
    register,
    control,
    handleSubmit,
    reset,
    trigger,
    setError,
    setValue,
  } = useForm();

  const brasilStateOptions = [
    { ID: 'AC', NOME: 'AC' },
    { ID: 'AL', NOME: 'AL' },
    { ID: 'AP', NOME: 'AP' },
    { ID: 'AM', NOME: 'AM' },
    { ID: 'BA', NOME: 'BA' },
    { ID: 'CE', NOME: 'CE' },
    { ID: 'DF', NOME: 'DF' },
    { ID: 'ES', NOME: 'ES' },
    { ID: 'GO', NOME: 'GO' },
    { ID: 'MA', NOME: 'MA' },
    { ID: 'MT', NOME: 'MT' },
    { ID: 'MS', NOME: 'MS' },
    { ID: 'MG', NOME: 'MG' },
    { ID: 'PA', NOME: 'PA' },
    { ID: 'PB', NOME: 'PB' },
    { ID: 'PR', NOME: 'PR' },
    { ID: 'PE', NOME: 'PE' },
    { ID: 'PI', NOME: 'PI' },
    { ID: 'RJ', NOME: 'RJ' },
    { ID: 'RN', NOME: 'RN' },
    { ID: 'RS', NOME: 'RS' },
    { ID: 'RG', NOME: 'RG' },
    { ID: 'RR', NOME: 'RR' },
    { ID: 'SC', NOME: 'SC' },
    { ID: 'SP', NOME: 'SP' },
    { ID: 'SE', NOME: 'SE' },
    { ID: 'TO', NOME: 'TO' },
  ];

  const alterValue = (e) => {
    const valor = e.target.value;

    if (valor.length >= 10) {
      dispatch(
        buscaCep(valor, (res) => {
          if (res.status == 200) {
            setRua(res.data.rua);
            setBairro(res.data.bairro);
            setCidade(res.data.cidade);
            setUf(res.data.uf);
            setNumero('');
            setComplemento('');
            res.data.bairro === null &&
            res.data.rua === null &&
            res.data.cidade === ''
              ? setCepError(true)
              : setCepError(false);
          } else {
            setCepError(true);
          }
        })
      );
    }
  };

  const onSubmit = (data) => {
    data.CPFCNPJ_CLIENTE = usersData.CPFCNPJ;
    !cepError &&
      (dispatch(editUserFetchAction(data, 'approvedUsers')),
      dispatch(userFetchAction(data.CPFCNPJ_CLIENTE, 'wontBeLoaded')),
      finall());
  };

  const resetState = () => {
    setIdCoban(usersData.ID_COBAN);
    setAcessoPdv(usersData.ACESSO_PDV);
    setPerfil(initialProfile[0]?.ID);

    setNome(cliente?.NOME);
    setCpf(cliente?.CPFCNPJ);
    setEmail(contato?.EMAIL);
    setCep(endereco?.CEP);
    setRua(endereco?.ENDERECO);
    setBairro(endereco?.BAIRRO);
    setCidade(endereco?.CIDADE);
    setUf(endereco?.UF);
    setNumero(endereco?.NUMERO);
    setComplemento(endereco?.COMPLEMENTO);
    setTelefone(contato?.FONECEL);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Styled.InformationContainer>
        <h3>SOBRE</h3>
        <Styled.Container width={'29.306vw'} margin={'1.389vw 0 0 0'}>
          <Styled.Title>{'Nome/Razão Social'}</Styled.Title>
          <Styled.Input
            width={'29.306vw'}
            disabled={true}
            name={'nome'}
            error={errors.NOME && true}
            {...register(`NOME`)}
            value={nome}
            onChange={(e) => {
              setNome(e.target.value);
            }}
          />
        </Styled.Container>
        <Styled.Row>
          <Styled.Container width={'13.958vw'} margin={'1.389vw 0 0 0'}>
            <Styled.Title>{'CPF/CNPJ'}</Styled.Title>
            <Styled.Input
              width={'13.958vw'}
              disabled={true}
              name={'cpfcnpj'}
              error={errors.cliente?.CPFCNPJ && true}
              {...register(`CPFCNPJ`)}
              value={cpf?.length === 11 ? formatCPF(cpf) : formatCNPJ(cpf)}
              onChange={(e) => {
                setCpf(e.target.value);
              }}
            />
          </Styled.Container>
          <Styled.Container width={'13.958vw'} margin={'1.389vw 0 0 1.389vw'}>
            <Styled.Title>{'Telefone'}</Styled.Title>
            <InputMask
              mask="(99)99999-9999"
              maskChar=""
              value={telefone}
              onChange={(e) => {
                setTelefone(e.target.value);
              }}
              disabled={true}
            >
              {(inputProps) => (
                <Styled.Input
                  width={'13.958vw'}
                  name={'TELEFONE'}
                  value={telefone}
                  error={errors.TELEFONE && true}
                  disabled={true}
                  {...inputProps}
                />
              )}
            </InputMask>
          </Styled.Container>
        </Styled.Row>
        <Styled.Container width={'29.306vw'} margin={'1.389vw 0 1.5vw 0'}>
          <Styled.Title>{'E-mail'}</Styled.Title>
          <Styled.Input
            width={'29.306vw'}
            type={'email'}
            disabled={true}
            name={'email'}
            error={errors.EMAIL && true}
            {...register(`EMAIL`)}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </Styled.Container>

        <Styled.Row>
          <OptionsContainerProfiles>
            <TitleOptions>Perfil</TitleOptions>
            <Styled.SelectStyled
              width={'17.3vw'}
              height={'3.3vw'}
              disabled={true}
              value={perfil}
              name={'PERFIL'}
              onChange={(e) => {
                setPerfil(e.target.value);
              }}
            >
              {perfisArray?.map((option) => (
                <MenuItem key={option.ID} value={option.ID}>
                  {option.NOME}
                </MenuItem>
              ))}
            </Styled.SelectStyled>
          </OptionsContainerProfiles>
        </Styled.Row>
      </Styled.InformationContainer>

      <Styled.InformationContainer>
        <h3>ENDEREÇO</h3>
        <Styled.Container width={'36vw'} margin={'1.389vw 0 0 0'}>
          <Styled.Title>{'Endereço'}</Styled.Title>
          <Styled.Input
            width={'36vw'}
            disabled={!isEditing}
            name={'endreco'}
            value={rua}
            error={errors.ENDERECO && true}
            required={true}
            {...register(`ENDERECO`)}
            onChange={(e) => {
              setRua(e.target.value);
            }}
          />
        </Styled.Container>
        <Styled.Row>
          <Styled.Container width={'5.208vw'} margin={'1.389vw 0 0 0'}>
            <Styled.Title>{'Número'}</Styled.Title>
            <Styled.Input
              width={'5.208vw'}
              disabled={!isEditing}
              name={'numero'}
              value={numero}
              error={errors.NUMERO && true}
              required={true}
              {...register(`NUMERO`)}
              onChange={(e) => {
                setNumero(e.target.value);
              }}
            />
          </Styled.Container>
          <Styled.Container width={'11.806vw'} margin={'1.389vw 0 0 1.389vw'}>
            <Styled.Title>{'Complemento'}</Styled.Title>
            <Styled.Input
              width={'11.806vw'}
              disabled={!isEditing}
              name={'complemento'}
              value={complemento}
              error={errors.COMPLEMENTO && true}
              {...register(`COMPLEMENTO`)}
              onChange={(e) => {
                setComplemento(e.target.value);
              }}
            />
          </Styled.Container>
          <Styled.Container width={'16.3vw'} margin={'1.389vw 0 0 1.389vw'}>
            <Styled.Title>{'Bairro'}</Styled.Title>
            <Styled.Input
              width={'16.3vw'}
              disabled={!isEditing}
              name={'bairro'}
              value={bairro}
              error={errors.BAIRRO && true}
              required={true}
              {...register(`BAIRRO`)}
              onChange={(e) => {
                setBairro(e.target.value);
              }}
            />
          </Styled.Container>
        </Styled.Row>
        <Styled.Row>
          <Styled.Container width={'20.806vw'} margin={'1.389vw 0 0 0'}>
            <Styled.Title>{'Cidade'}</Styled.Title>
            <Styled.Input
              width={'18.3vw'}
              disabled={!isEditing}
              name={'cidade'}
              value={cidade}
              error={errors.CIDADE && true}
              required={true}
              {...register(`CIDADE`)}
              onChange={(e) => {
                setCidade(e.target.value);
              }}
            />
          </Styled.Container>
          <OptionsContainer>
            <TitleOptions>UF</TitleOptions>
            <Styled.SelectStyled
              height={'3.3vw'}
              disabled={!isEditing}
              defaultValue={uf}
              value={uf}
              name={'uf'}
              required={true}
              onChange={(e) => {
                setUf(e.target.value);
              }}
            >
              {brasilStateOptions?.map((option) => (
                <MenuItem key={option.ID} value={option.ID}>
                  {option.NOME}
                </MenuItem>
              ))}
            </Styled.SelectStyled>
          </OptionsContainer>
        </Styled.Row>
        <Styled.Container width={'20.806vw'} margin={'2.919vw 0 0 0'}>
          <Styled.Title>{'Cep'}</Styled.Title>
          <Styled.Input
            width={'20.806vw'}
            disabled={!isEditing}
            name={'cep'}
            value={formatCEP(cep)}
            inputProps={{ maxLength: 10 }}
            error={cepError}
            helperText="Cep incorreto."
            required={true}
            {...register(`CEP`)}
            onChange={(e) => {
              setCep(e.target.value);
              alterValue(e);
            }}
          />
          {cepError && (
            <FormHelperText style={{ color: 'red' }} id="component-error-text">
              Cep incorreto.
            </FormHelperText>
          )}
        </Styled.Container>
        <Styled.ButtonContainer>
          {isEditing && (
            <>
              <Button
                backgroundColor={rbmWhite}
                width={'12.153vw'}
                height={'3.333vw'}
                hoverBGColor={secondaryColor}
                hoverColor={rbmWhite}
                color={rbmBlack}
                onClick={() => {
                  resetState();
                  cancel();
                }}
              >
                <span>CANCELAR</span>
              </Button>
              <Button
                backgroundColor={secondaryColor}
                width={'12.153vw'}
                height={'3.333vw'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={rbmWhite}
                type="submit"
                onClick={() => {
                  setValue('CEP', cep);
                  setValue('CIDADE', cidade);
                  setValue('ENDERECO', rua);
                  setValue('BAIRRO', bairro);
                  setValue('EMAIL', email);
                  setValue('NOME', nome);
                  setValue('NUMERO', numero);
                  setValue('COMPLEMENTO', complemento);
                  setValue('ID_COBAN', idCoban);
                  setValue('ACESSO_PDV', acessoPdv);
                  setValue('NASCIMENTO', data);
                  setValue('TELEFONE', telefone);
                  setValue('UF', uf);
                  verifyArray(initialProfile) &&
                    initialProfile[0] &&
                    setValue('PERFIL', perfil);
                }}
              >
                <span>SALVAR</span>
              </Button>
            </>
          )}
        </Styled.ButtonContainer>
      </Styled.InformationContainer>
    </form>
  );
}

UserDetail.propTypes = {
  control: PropTypes.any,
  setValue: PropTypes.any,
  register: PropTypes.any,
  isEditing: PropTypes.bool,
  cancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  call: PropTypes.func,
  errors: PropTypes.object,
};
